<template>
    <div id="dealer-page">
        <section-definition
                :title="page.title"
                :menuItems="menuItems"
        >
        </section-definition>


        <v-dialog v-model="dialog" persistent max-width="700px" attach="#dealer-page" :light="custom_islight">
            <!--<template v-slot:activator="{ on }">-->
                <!--<v-btn color="primary" dark class="mb-2" v-on="on">Add Dealership</v-btn>-->
            <!--</template>-->
            <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form">
                        <v-container fluid grid-list-md page>
                            <v-layout wrap>
                                <v-flex xs12 sm6 md5>
                                    <v-autocomplete
                                        :items="dealer_groups"
                                        label="Dealer Group*"
                                        item-value="_id"
                                        item-text="name"
                                        v-model="editedItem.org_id"
                                        v-on:change="set_selected_group"
                                        :rules="[x => isRequired(x, 'Group')]"
                                        :disabled="!allow_org_change"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 md7>
                                    <v-checkbox
                                            v-if="editedIndex!==-1"
                                            label="Enable Dealer Group Change"
                                            v-model="allow_org_change"
                                    ></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                    <v-text-field  v-model="editedItem.name" label="Dealership Name*"
                                                   :rules="[x => isRequired(x, 'Group')]"></v-text-field>
                                </v-flex>
                                <!--<v-flex xs12 sm12 md12>-->
                                    <!--<v-text-field v-model="editedItem.address_street1" label="Street 1"></v-text-field>-->
                                <!--</v-flex>-->
                                <!--<v-flex xs12 sm12 md12>-->
                                    <!--<v-text-field v-model="editedItem.address_street2" label="Street 2"></v-text-field>-->
                                <!--</v-flex>-->
                                <v-flex xs12 sm12 md4>
                                    <v-text-field v-model="editedItem.address_city" label="City"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <!--<v-text-field v-model="editedItem.address_state" label="State"></v-text-field>-->
                                    <v-autocomplete
                                        label="State*"
                                        :items="states"
                                        item-value="abbr"
                                        item-text="txt"
                                        v-model="editedItem.address_state"
                                        :rules="[x => isRequired(x, 'State')]"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field v-model="editedItem.address_zip" label="Zip"></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                        label="Leads Per Agent*"
                                        v-model="editedItem.leads_per_salesperson"
                                        :rules="[x => checkRange(x, 0, 100, ), x => isRequired(x, 'Leads/Agent')]"
                                        hint="The number of leads that will be graded per sales person each month."
                                    ></v-text-field>

                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-autocomplete
                                        :items="timezones"
                                        label="Time Zone*"
                                        v-model="editedItem.timezone"
                                        item-value="value"
                                        item-text="text"
                                        :rules="[x => isRequired(x, 'Group')]"
                                    ></v-autocomplete>
                                </v-flex>

                                <v-flex xs12 sm6 md4>
                                    <v-select
                                        :items="[{text:'Yes', value:true}, {text:'No', value:false}]"
                                        label="Account Active?"
                                        v-model="editedItem.is_active"
                                        item-value="value"
                                        item-text="text"
                                        required
                                        :light="custom_islight"
                                    ></v-select>
                                </v-flex>
                                <!--<v-flex xs0 sm0 md4></v-flex>-->


                               <v-flex xs12 >
                                  <v-autocomplete
                                      :items="['SalesPerson', 'Manager']"
                                      label="Gradable Users"
                                      v-model="editedItem.gradable_user_types"
                                      multiple

                                  ></v-autocomplete>
                               </v-flex>





                                <v-expansion-panel class="mt-3" v-if="is_agency">
                                    <v-expansion-panel-content>
                                        <template v-slot:header>
                                            <div>Edit Curriculum Settings</div>
                                        </template>

                                        <v-card class="pl-2 pr-2">
                                            <v-card-text>

                                                <div>Note that these should only be set if you wish to over ride
                                                    the default curriculum set at
                                                the Organization.</div>
                                                <v-layout wrap>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-autocomplete
                                                                label="Level 1 Curriculum"
                                                                :items="curricula"
                                                                item-value="_id"
                                                                item-text="name"
                                                                v-model="editedItem.curricula.level_1"
                                                                :rules="[x => isRequired2(x, 'Curriculum',{nullOk: true} )]"
                                                                required
                                                        ></v-autocomplete>
                                                    </v-flex>

                                                    <v-flex xs12 sm6 md6>
                                                        <v-autocomplete
                                                                label="Level 2 Curriculum"
                                                                :items="curricula"
                                                                item-value="_id"
                                                                item-text="name"
                                                                v-model="editedItem.curricula.level_2"
                                                                :rules="[x => isRequired2(x, 'Curriculum', {nullOk: true})]"
                                                                required
                                                        ></v-autocomplete>
                                                    </v-flex>

                                                    <v-flex xs12 sm6 md6>
                                                        <v-autocomplete
                                                                label="Level 3 Curriculum"
                                                                :items="curricula"
                                                                item-value="_id"
                                                                item-text="name"
                                                                v-model="editedItem.curricula.level_3"
                                                                :rules="[x => isRequired2(x, 'Curriculum', {nullOk: true})]"
                                                                required
                                                        ></v-autocomplete>
                                                    </v-flex>

                                                    <v-flex xs12 sm6 md6>
                                                        <v-autocomplete
                                                                label="Level 4 Curriculum"
                                                                :items="curricula"
                                                                item-value="_id"
                                                                item-text="name"
                                                                v-model="editedItem.curricula.level_4"
                                                                :rules="[x => isRequired2(x, 'Curriculum',{nullOk: true})]"
                                                                required
                                                        ></v-autocomplete>
                                                    </v-flex>

                                                </v-layout>

                                            </v-card-text>

                                        </v-card>

                                    </v-expansion-panel-content>
                                <!--</v-expansion-panel>-->




                                <!--------------dealer settings for crm------------------------------------------------>
                                <!--<v-expansion-panel class="mt-3" v-if="is_agency">-->
                                    <v-expansion-panel-content>
                                        <template v-slot:header>
                                            <div>Edit CRM Info</div>
                                        </template>

                                        <v-card class="pl-2 pr-2">
                                            <v-card-text>
                                                <v-layout wrap>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field
                                                                label="CRM Name"
                                                                v-model="editedItem.info_crm.name"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field
                                                                label="CRM URL"
                                                                v-model="editedItem.info_crm.url"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field
                                                                label="Username"
                                                                hint="User name for CRM"
                                                                v-model="editedItem.info_crm.username"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field
                                                                label="Password"
                                                                hint="Password for CRM user"
                                                                v-model="editedItem.info_crm.password"
                                                        ></v-text-field>
                                                    </v-flex>

                                                </v-layout>

                                            </v-card-text>

                                        </v-card>

                                    </v-expansion-panel-content>



                                   <!--------------Manager Teacher ------------------------------------------------>

                                   <v-expansion-panel-content>
                                      <template v-slot:header>
                                         <div>Management Teacher</div>
                                      </template>

                                      <v-card class="pl-2 pr-2">
                                         <v-card-text>
                                            <v-layout wrap>
                                               <v-flex xs12 sm6 md6>
                                                  <v-checkbox
                                                      label="Enabled"
                                                      v-model="editedItem.mgm_teacher.enabled"
                                                  />
                                               </v-flex>

                                               <v-flex xs12 sm6 md6>
                                                  <v-autocomplete
                                                      label="Coach-Up Threshold"
                                                      v-model="editedItem.mgm_teacher.thresh_grade_letter_ix"
                                                      :items="letter_grades"
                                                      item-text="grade"
                                                      item-value="ix"
                                                      hint="Leads graded at or below this will be que-ed for mgm coach up"
                                                  />
                                               </v-flex>

                                            </v-layout>

                                         </v-card-text>



                                         <v-card-text>
                                            <div>Choose coaching curriculum for managers</div>
                                            <v-layout wrap>
                                               <v-flex xs12 sm12 md12>
                                                  <v-autocomplete
                                                      label="Coach Up Curriculum"
                                                      :items="curricula"
                                                      item-value="_id"
                                                      item-text="name"
                                                      v-model="editedItem.mgm_teacher.curricula.default"
                                                      :rules="[x => isRequired2(x, 'Curriculum',{nullOk: true, disabled: !editedItem.mgm_teacher.enabled} )]"
                                                      required
                                                  ></v-autocomplete>
                                               </v-flex>


                                               <!--<v-flex xs12 sm6 md6>-->
                                               <!--   <v-autocomplete-->
                                               <!--       label="Level 2 Coach Up Curriculum"-->
                                               <!--       :items="curricula"-->
                                               <!--       item-value="_id"-->
                                               <!--       item-text="name"-->
                                               <!--       v-model="editedItem.mgm_teacher.curricula.level_2"-->
                                               <!--       :rules="[x => isRequired2(x, 'Curriculum', {nullOk: true, disabled: !editedItem.mgm_teacher.enabled})]"-->
                                               <!--       required-->
                                               <!--   ></v-autocomplete>-->
                                               <!--</v-flex>-->

                                               <!--<v-flex xs12 sm6 md6>-->
                                               <!--   <v-autocomplete-->
                                               <!--       label="Level 3 Coach Up Curriculum"-->
                                               <!--       :items="curricula"-->
                                               <!--       item-value="_id"-->
                                               <!--       item-text="name"-->
                                               <!--       v-model="editedItem.mgm_teacher.curricula.level_3"-->
                                               <!--       :rules="[x => isRequired2(x, 'Curriculum', {nullOk: true, disabled: !editedItem.mgm_teacher.enabled})]"-->
                                               <!--       required-->
                                               <!--   ></v-autocomplete>-->
                                               <!--</v-flex>-->

                                               <!--<v-flex xs12 sm6 md6>-->
                                               <!--   <v-autocomplete-->
                                               <!--       label="Level 4 Coach Up Curriculum"-->
                                               <!--       :items="curricula"-->
                                               <!--       item-value="_id"-->
                                               <!--       item-text="name"-->
                                               <!--       v-model="editedItem.mgm_teacher.curricula.level_4"-->
                                               <!--       :rules="[x => isRequired2(x, 'Curriculum',{nullOk: true, disabled: !editedItem.mgm_teacher.enabled})]"-->
                                               <!--       required-->
                                               <!--   ></v-autocomplete>-->
                                               <!--</v-flex>-->

                                            </v-layout>

                                         </v-card-text>


                                      </v-card>

                                   </v-expansion-panel-content>
                                </v-expansion-panel>

                               <!--------------------- end of expansion panels ---------------------------------------->



                            </v-layout>
                        </v-container>
                    </v-form>

                    <v-layout row class="pt-4">
                        <v-flex xs12 pl-3>

                            <span>Dealership Sales People (Total Leads for Dealership =
                                {{dealer_users_sp.length * editedItem.leads_per_salesperson}})</span>
                            <div class="pt-2"></div>
                            <div v-for="(item, i) in dealer_users_sp" :key="item.user_id">
                                {{item.name}} ({{item.email}})
                            </div>
                        </v-flex>
                    </v-layout>

                    <v-layout row v-if="form_error">
                        <!--<v-flex grow></v-flex>-->
                        <v-spacer></v-spacer>
                        <v-flex shrink class="pr-3 red--text"> {{form_error}}</v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close">Cancel</v-btn>
                    <v-btn color="primary" @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



        <!-------------------------------------------------main data--------------------------------------------------->
        <v-container fluid grid-list-xl page>
            <v-card-title  >
                <v-btn color="primary" dark class="mb-2" @click="dialog=true">Add Dealership</v-btn>
                <v-switch
                        v-model="showOnlyActive"
                        :label="'Show only Active Accounts'"
                        color="primary"
                        v-on:change="update_dealers"
                ></v-switch>

                <v-spacer></v-spacer>
                <v-text-field
                        v-model="search_txt"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                ></v-text-field>
            </v-card-title>

            <v-data-table
                    :headers="headers"
                    :items="dealers"
                    :search="search_txt"
                    :light="custom_islight"
                    :rows-per-page-items="pagination"
                    class="elevation-1 border-radius6"
                    :loading="data_loading"
            >
                <template slot="items" slot-scope="props">
                    <tr v-bind:class="get_row_class(props.item.is_active)"
                        class="row"
                        @click="editItem(props.item)"
                        :key="props.item._id"
                    >
                        <!--<td>{{ props.item.dealer_num }}</td>-->
                        <td>{{ props.item.org_id ? props.item.org_id.name: '' }}</td>
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.address_city }}</td>
                        <td>{{ props.item.address_state }}</td>
                        <td>{{ props.item.is_active ? 'Yes' : 'No' }}</td>
                        <td class="justify-center">
                            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                            <!--<v-icon small @click="deleteItem(props.item)"> delete </v-icon>-->
                        </td>
                    </tr>


                </template>
                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search_txt }}" found no results.
                    </v-alert>
                </template>
            </v-data-table>

        </v-container>


        <my-show-error
            v-model="dialog_show_error"
            :error="show_error_obj"
        ></my-show-error>

    </div>
</template>


<style scoped>
    .row_inactive {
        color: #b8b8b8;
    }
    .error_txt{
        color: red;
    }

    .row{
        cursor: pointer;
    }
</style>



<script>
   import axios from 'axios';
   import data_getters from '../mixins/data_getters'
   import validate from '../mixins/validation'
   import states_data from '../data/states.js';
   // const _ = require('underscore');

   //https://stackoverflow.com/questions/7176908/how-to-get-index-of-object-by-its-property-in-javascript/54015295
   function findWithAttr(array, attr, value) {

      for(var i = 0; i < array.length; i += 1) {
         if(array[i][attr] === value) {
            return i;
         }
      }
      return -1;
   }


   let editedItemDefault = {
      name: '',
         org_id: null,
         address_street1: '',
         address_street2: '',
         address_city: '',
         address_state: '',
         address_zip: '',
         leads_per_salesperson: null,
         timezone: null,
         is_active: true,
         curricula: {
            "level_1" : null,
            "level_2" : null,
            "level_3" : null,
            "level_4" : null
         },
         info_crm: {},
         mgm_teacher: {
            thresh_grade_letter_ix: 8,
            curricula: {}
         },
   };

   export default {
      name: 'ManageDealer',
      mixins: [data_getters, validate],
      data() {
         return {
            custom_islight: true,

            timezones:[
               'US/Pacific',
               'US/Mountain',
               'US/Central',
               'US/Eastern'
            ],
            //data for dealers list
            headers: [
               // {text: 'ID', value: 'dealer_num'},
               {text: 'Group Name', value: 'org_id.name'},
               {text: 'Dealership Name', value: 'name'},
               {text: 'City', value: 'address_city'},
               {text: 'State', value: 'address_state'},
               {text: 'Active', value: 'is_active'},
               {text: 'Edit', value:"" },
            ],
            dealers: [],
            pagination: [25, 50, 100, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
            showOnlyActive: true,

            data_loading: true,

            allow_org_change: true,
            dealer_groups: [],
            dealer_group_selected: null,
            dealer_users_sp: [], //sales people
            dealer_users_mgm: [], //managers
            states: states_data,
            form_error: null,

            //search bar
            search_txt: '',

            //add new/edit dialog
            formTitle: 'Add New Dealership',
            dialog: false,
            editedIndex: -1,
            editedItem: JSON.parse(JSON.stringify(editedItemDefault)) ,
            //    {
            //    name: '',
            //    org_id: null,
            //    address_street1: '',
            //    address_street2: '',
            //    address_city: '',
            //    address_state: '',
            //    address_zip: '',
            //    leads_per_salesperson: null,
            //    timezone: null,
            //    is_active: true,
            //    curricula: {},
            // },
            //


            curricula: [],
            curricula_all: [],
            curricula_active: [],




            //main page header
            page: {
               title: "Manage Dealers",
               headline: "Black Page",
            },
            menuItems: [
               {title: "Only Show Active Accounts", value: true}
            ],
            breadcrumbs: [
               {
                  text: "Src",
                  disabled: false
               },
               {
                  text: "Views",
                  disabled: false
               },
               {
                  text: "Blank 2",
                  disabled: false
               }
            ]
         };
      },
      computed:{
        is_agency(){
           return this.$auth.profile.acct_type === 'AGENCY';
        },

         letter_grades(){
            let letter_grades =  ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'];
            let ans = [];
            for (let i=0; i<letter_grades.length; i++){
               ans.push({
                  ix: i,
                  grade: letter_grades[i]
               })
            }
            return ans;
         },
      },
      methods:{

         async update_dealers(){

            this.data_loading = true;
            this.dealers = await this.get_dealers({is_active: this.showOnlyActive, include_crm_info:true});
            this.data_loading = false;
         },
         //*************************************************************************************************************
         /**
          * keeps track of the dealer group that's be selected in the edit dialog
          * @param val - value passed from dealer group v-select element, needs to be the _id prop, not the whole group object
          */
         set_selected_group(val){
           let i = findWithAttr(this.dealer_groups, '_id', val);
           this.dealer_group_selected = this.dealer_groups[i];
           // console.log(i, val)

            if (this.editedIndex === -1){
               this.copy_org_data();
            }


         },

         //*************************************************************************************************************
         close () {
            this.dialog = false;
            setTimeout(() => {
               this.editedItem = Object.assign({}, editedItemDefault);
               this.editedIndex = -1;
               this.$refs.form.resetValidation();
               this.form_error = null;
               this.allow_org_change = true;
               this.curricula = this.curricula_active;
               this.formTitle = 'Add New Dealership';
            }, 300)
         },

         copy_org_data(){
            if (this.editedIndex === -1){

               if (this.editedItem.name ==='') this.editedItem.name = this.dealer_group_selected.name;
               if (this.editedItem.address_city ==='') this.editedItem.address_city = this.dealer_group_selected.address_city;
               if (this.editedItem.address_state ==='') this.editedItem.address_state = this.dealer_group_selected.address_state;
               if (this.editedItem.address_zip ==='') this.editedItem.address_zip = this.dealer_group_selected.address_zip;

            }

         },

         //*************************************************************************************************************
         async editItem (item) {
            this.editedIndex = this.dealers.indexOf(item);
            this.editedItem = JSON.parse(JSON.stringify(item));

            if (this.editedItem.gradable_user_types == null){
               this.editedItem.gradable_user_types = ['SalesPerson'];
            }

            if (this.editedItem.mgm_teacher == null){
               this.editedItem.mgm_teacher =  {
                  thresh_grade_letter_ix: 8,
                  curricula: {}
               };
            }

            if (this.editedItem.mgm_teacher.curricula == null){
               this.editedItem.mgm_teacher.curricula =  {};
            }

            this.allow_org_change = false;
            this.curricula = this.curricula_all;

            this.formTitle = 'Edit Dealership';

            this.editedItem.org_id = this.editedItem.org_id._id;
            // this.editedItem.is_active = post_data.is_active.value;

            let users = await this.get_users({dealer_id: this.editedItem._id, is_active: true});

            this.dealer_users_sp = [];
            this.dealer_users_mgm = [];
            for (let i=0; i<users.length; i++){
               if (users[i].app_metadata.role === 'SalesPerson'){
                  this.dealer_users_sp.push(users[i]);
               }
               if (['Admin', 'Manager'].includes(users[i].app_metadata.role) ){
                  this.dealer_users_mgm.push(users[i]);
               }
            }

            this.editedItem.num_salespeople = this.dealer_users_sp.length;
            this.dialog = true;

         },

         //*************************************************************************************************************
         async save () {


            if (this.$refs.form.validate()){

               if (this.$auth.profile.user_role !== 'SuperAdmin'){
                  this.editedItem.agency_id = this.$auth.profile.agency_id;
               }

               let post_data = JSON.parse(JSON.stringify(this.editedItem));

               delete post_data.updatedAt;
               delete post_data.createdAt;
               delete post_data.__v;
               delete post_data.dealer_num;

               //save to db
               try {
                  console.log('post_data', post_data);
                  let token = await this.$auth.getAxiosHeader();
                  let url = this.$baseUrlApi + '/updateDealership';

                  var res = await axios.post(url, post_data, token);

                  // insert new doc into UI
                  await this.update_dealers();
                  this.close();
               }
               catch(err){
                  // console.log(err)
                  this.form_error = this.show_error_details(err, 'Saving dealer on dealer manage page');
                  // this.form_error = 'There was an error saving.  Please contact tech support.'
               }
            }
            else{
               this.form_error = 'Please check highlighted fields'

            }


         },



         //*************************************************************************************************************
         deleteItem (item) {
            const index = this.dealers.indexOf(item);
            confirm('Are you sure you want to delete this item?') && this.dealers.splice(index, 1)
         },
      },

      async created(){
         this.get_curricula().then(data =>{
            for (let i=0; i<data.length; i++){

               if (!data[i].is_active){
                  data[i].name = data[i].name + " (inactive)"
               }
            }
            data.unshift({_id: null, name: 'None'});
            this.curricula_all = data;
         });

         this.get_curricula({is_active:true}).then(data =>{
            data.unshift({_id: null, name: 'None'});
            this.curricula_active = data;
            this.curricula = this.curricula_active;
         });


         this.update_dealers();
         this.dealer_groups = await this.get_organizations();

      }



   };
</script>
